import About from "../components/About";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer"

export default function AboutPage() {
  return (
    <div>
         <Navbar />
      <About/>
                     <Footer/>
    </div>
  );
}
